import moment from "moment-timezone";

export const TIME_ZONE = moment.tz.guess();

export const BEGINNING_OF_TIME = moment("1900-01-01").format("YYYY-MM-DD");

export const TODAY = moment().format("YYYY-MM-DD");

export const YESTERDAY = moment().subtract(1, "day").format("YYYY-MM-DD");

export const START_OF_THIS_WEEK = moment().startOf("isoWeek").format("YYYY-MM-DD");

export const FIRST_DAY_OF_LAST_WEEK = moment()
  .subtract(7, "day").startOf("isoWeek")
  .format("YYYY-MM-DD");

export const LAST_DAY_OF_LAST_WEEK = moment()
  .subtract(7, "day").endOf("isoWeek")
  .format("YYYY-MM-DD");

export const START_OF_THIS_MONTH = moment().startOf("month").format("YYYY-MM-DD");

export const FIRST_DAY_OF_LAST_MONTH = moment()
  .subtract(1, "month").startOf("month")
  .format("YYYY-MM-DD");

export const LAST_DAY_OF_LAST_MONTH = moment()
  .subtract(1, "month").endOf("month")
  .format("YYYY-MM-DD");

// 7 days ago, INCLUDING today
export const SEVEN_DAYS_AGO_INCLUSIVE = moment().subtract(6, "days").format("YYYY-MM-DD");

export const SEVEN_DAYS_AGO = moment().subtract(7, "days").format("YYYY-MM-DD");

export const THIRTY_DAYS_AGO = moment().subtract(30, "days").format("YYYY-MM-DD");

export const START_OF_THIS_YEAR = moment().startOf("year").format("YYYY-MM-DD");

export const FIRST_DAY_OF_LAST_YEAR = moment()
  .subtract(1, "year").startOf("year")
  .format("YYYY-MM-DD");

export const LAST_DAY_OF_LAST_YEAR = moment()
  .subtract(1, "year").endOf("year")
  .format("YYYY-MM-DD");

export const DEFAULT_START_DATE = SEVEN_DAYS_AGO;
export const DEFAULT_ALL_START_DATE = BEGINNING_OF_TIME;
export const DEFAULT_END_DATE = YESTERDAY;


/**
 * Express a date range by a string
 *
 * @param {string} startDate YYYY-MM-DD
 * @param {string} endDate YYYY-MM-DD
 * @returns {string}
 */
export function getDateRangeString(startDate: string, endDate: string): string {
  if (startDate === BEGINNING_OF_TIME && endDate === TODAY) {
    return "alltime";
  }

  if (startDate === TODAY && endDate === TODAY) {
    return "today";
  }

  if (startDate === YESTERDAY && endDate === YESTERDAY) {
    return "yesterday";
  }

  if (startDate === START_OF_THIS_WEEK && endDate === TODAY) {
    return "weekToDate";
  }

  if (startDate === FIRST_DAY_OF_LAST_WEEK && endDate === LAST_DAY_OF_LAST_WEEK) {
    return "lastWeek";
  }

  if (startDate === SEVEN_DAYS_AGO_INCLUSIVE && endDate === TODAY) {
    return "last7DaysInclusive";
  }

  if (startDate === SEVEN_DAYS_AGO && endDate === YESTERDAY) {
    return "last7Days";
  }

  if (startDate === START_OF_THIS_MONTH && endDate === TODAY) {
    return "monthToDate";
  }

  if (startDate === FIRST_DAY_OF_LAST_MONTH && endDate === LAST_DAY_OF_LAST_MONTH) {
    return "lastMonth";
  }

  if (startDate === THIRTY_DAYS_AGO && endDate === YESTERDAY) {
    return "last30Days";
  }

  if (startDate === START_OF_THIS_YEAR && endDate === TODAY) {
    return "yearToDate";
  }

  if (startDate === FIRST_DAY_OF_LAST_YEAR && endDate === LAST_DAY_OF_LAST_YEAR) {
    return "lastYear";
  }

  return "custom";
}

export function getAnalyticsDateStringFromTimestamp(timestamp: number): string {
  return moment.unix(timestamp).format("MMM DD, YYYY LT");
}
